import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import type { PapiDeviation } from '@wix/da-papi-types';
import ShopCardRoot, { ShopCardRootProps } from '../_partials/ShopCardRoot';
import DeviationThumbIndicators, {
  AllowedIndicators,
} from '../../DeviationViews/Thumb/legos/DeviationThumbIndicators';
import s from './HiddenShopCard.scss';

interface Props extends Omit<ShopCardRootProps, 'children' | 'height'> {
  deviation: PapiDeviation;
  height: number;
}

const HiddenShopCard: React.FC<Props> = ({
  deviation,
  width,
  height,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <ShopCardRoot
      height={height}
      width={width}
      className={c(s['root'], className)}
    >
      <div className={s['gradient-underlay']} />
      <div className={s['indicators-slot']}>
        <DeviationThumbIndicators
          deviation={deviation}
          allowedIndicators={AllowedIndicators.Flag}
        />
      </div>
      <div className={s['text']}>
        <div className={s['heading']}>
          {t('shop.thumb.hidden.privatePurchase.heading')}
        </div>
        <p className={s['subtext']}>
          {t('shop.thumb.hidden.privatePurchase.subtext')}
        </p>
      </div>
    </ShopCardRoot>
  );
};

HiddenShopCard.displayName = 'HiddenShopCard';

export default HiddenShopCard;
